import { webAiStreamReader as e } from "./webAiStreamReader.mjs";
import { createContext as t, useContext as n } from "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/stream/AiStreamReaderContext.tsx
var i = t(e), a = ({ reader: e, children: t }) => /* @__PURE__ */ r(i.Provider, {
	value: e,
	children: t
}), o = () => n(i);
//#endregion
export { a as AiStreamReaderProvider, o as useAiStreamReader };
